import { UCConsentServiceNames } from '../../../integrations/userCentrics/const';

export const DEFAULT_COOKIE_EXPIRATION_DAYS = 30;

// List of all the cookies used throughout the app
export enum CookieNames {
    Gender = 'bsGenderPage',
    Cart = 'onlyCart',

    // Called device, but it is actually exposing the client (browser name or webview).
    Client = 'device',

    // The SDK's site/locale cookie.
    Locale = '_msdyn365___site_',

    // The SDK's user consent cookie, which gates all non-essential SDK cookie writes.
    UserConsent = '_msdyn365___ucc_'
}

// Cookies that are only set when the user has consented to the corresponding service.
export enum ConsentGatedCookieNames {
    Relewise = 'uc-controller-id-relewise'
}

export const CONSENT_GATED_SERVICES = [
    {
        serviceName: UCConsentServiceNames.Relewise,
        cookieName: ConsentGatedCookieNames.Relewise
    }
];
